import type { RouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ResponseType = paths['/v3/users/{id}']['get']['responses']['200']['content']['application/json'];
type UserPathRequestParams = paths['/v3/users/{id}']['get']['parameters']['path'];

export const getUser = async ({ routeParams: { id } }: RouteParamsRequest<UserPathRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.user.get(id));
